import { BusinessEntityInterface } from '@/components/compliances/types/BusinessEntityInterface'

type businessEntityFromGraphqlInput = Omit<BusinessEntityInterface, 'data'> & {
  data: string | object
}

export default function businessEntityFromGraphql(
  input: businessEntityFromGraphqlInput | null,
): BusinessEntityInterface {
  const {
    globalId = '',
    entityType = 'common_business',
    isPrimary = false,
    label = null,
    companyNo = null,
    companyName = null,
    taxNo = null,
    data = {},
  } = input ?? {}
  return {
    globalId,
    entityType,
    isPrimary,
    label,
    companyNo,
    companyName,
    taxNo,
    data: typeof data === 'string' ? JSON.parse(data) : data,
  }
}
